<template>
  <el-dialog title="京东到家登录" :visible.sync="cookieDialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="login-container">
    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="100px">
      <el-form-item label="用户名" prop="accountName">
        <el-input v-model="loginForm.accountName" placeholder="请输入用户名"></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
      </el-form-item>

      <el-form-item label="验证码" prop="msgCode">
       <div class="flex">
        <el-input v-model="loginForm.msgCode" placeholder="请输入验证码"></el-input>
        <el-button type="primary" :disabled="isSending" @click="sendCaptcha">{{ captchaButtonText }}</el-button>
       </div>
      </el-form-item>
    </el-form>
  </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="handleLogin">登 录</el-button>
      </div>
    </el-dialog>
</template>

<script>
import jingdongApi from '@/api/plus/jingdong.js';

export default {
  data() {
    return {
      cookieDialogVisible:true,
      loginForm: {
        accountName: '18001136918',
        password: 'Hst-123456',
        msgCode: ''
      },
      rules: {
        accountName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        msgCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      isSending: false,
      countdown: 60,
      timer: null,
      captchaButtonText: '发送验证码'
    };
  },
  methods: {
    sendCaptcha() {
      let self = this
      if(!self.loginForm.accountName){
        self.$message.warning('请输入用户名')
        return
      }
      if (self.isSending) return; // 如果正在发送验证码，直接返回
      self.isSending = true;
      self.captchaButtonText = `${self.countdown}秒后重发`;
      jingdongApi.smsCode({
        accountName: self.loginForm.accountName
      }).then(res => {
        if (res.code === 1) {
            self.$message.success(res.data.content)
        }
      })
       // 开始倒计时
       self.timer = setInterval(() => {
              self.countdown--;
        if (self.countdown <= 0) {
          clearInterval(self.timer);
          self.isSending = false;
          self.captchaButtonText = '发送验证码';
          thselfis.countdown = 60; // 重置倒计时
        } else {
          self.captchaButtonText = `${self.countdown}秒后重发`;
        }
      }, 1000);
    },
    handleLogin() {
      const self = this
      self.$refs.loginForm.validate((valid) => {
        if (valid) {
          jingdongApi.JddjLogin({
            ...self.loginForm
          }).then(res => {
        if (res.code === 1) {
          jingdongApi.saveJddjCookiesSetting({
            jddjCookies:res.msg
          }).then(res2 => {
            if (res2.code === 1) {
              self.$message.success('保存成功，请重新进行同步')
              self.dialogFormVisible()
            }
            self.btnLoading = false

          }).catch(err => {
            self.btnLoading = false
          })
        }
        self.btnLoading = false

      }).catch(err => {
        self.btnLoading = false
      })
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    dialogFormVisible(e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      }
  }
};
</script>

<style scoped>
.login-container {
  width: 400px;
  margin: 100px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/jingdong/components/jdLogin.vue